import type { DrawLevel, ModLevels } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Prize from '../../Prize/Prize';

import styles from './PrizeRows.scss';
import { PRIZE_TRANSLATIONS } from './prizeData';

interface PrizeRowsProps {
  transposedData: DrawLevel[];
  modLevels: ModLevels[] | undefined;
  scalePM: number;
  currency: number;
  selectedPlayerIndex: number;
}

const PrizeRows: React.FC<PrizeRowsProps> = ({
  transposedData,
  modLevels,
  scalePM,
  currency,
  selectedPlayerIndex
}) => {
  const prizePlaces = PRIZE_TRANSLATIONS.slice(0, modLevels?.[selectedPlayerIndex]?.numUsers);

  return (
    <>
      {prizePlaces.map((_prizeData, prizeIndex) => (
        <tr key={prizeIndex} className={styles.prizeRow}>
          <th className={styles[prizePlaces[prizeIndex].key]}>
            <div className={styles.gamePrizeContent}>
              {prizeIndex < 3 && <i className={styles.iconCup} />}
              <Translation {...prizePlaces[prizeIndex].translation} />
            </div>
          </th>

          {transposedData.map((level, drawIndex) => {
            const awardItem = level.placeAwards?.[prizeIndex];

            if (!awardItem) {
              return <td key={`no-${drawIndex}`} data-testid="empty" />;
            }

            return (
              <Prize
                key={`${awardItem}-${drawIndex}`}
                value={
                  scalePM && typeof awardItem !== 'string' ? (awardItem ?? 0) * scalePM : awardItem
                }
                currency={currency}
                isCurrency
                star={prizeIndex === 0 && drawIndex !== 0 ? true : false}
              />
            );
          })}
        </tr>
      ))}
    </>
  );
};

export default PrizeRows;
